import { style, styleVariants, globalStyle } from '@vanilla-extract/css';
import { vars } from '../../theme';
import { reducedMotion } from '../../theme/media';

export type RadioSize = 'sm' | 'md' | 'lg';

export const root = style({
  display: 'inline-flex',
  alignItems: 'center',
  gap: vars.spacing.gap.sm,
  cursor: 'pointer',
  userSelect: 'none',
  fontFamily: vars.typography.fontFamily.primary,
  color: vars.typography.textColor.primary,
});

export const rootDisabled = style({
  cursor: 'not-allowed',
  opacity: 0.5,
});

export const controlWrapper = style({
  position: 'relative',
  display: 'inline-flex',
  flexShrink: 0,
});

export const nativeInput = style({
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  margin: 0,
  opacity: 0,
  cursor: 'inherit',
});

const ringBase = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box' as const,
  borderRadius: vars.spacing.borderRadius.full,
  background: vars.form.fieldGradient,
  border: `1px solid ${vars.surface.border.primary}`,
  boxShadow: vars.form.fieldInsetShadow,
  transition: `border-color ${vars.animation.duration.fast} ${vars.animation.easing.easeOut}`,
  '@media': { [reducedMotion]: { transition: 'none' } },
} as const;

export const ring = styleVariants({
  sm: { ...ringBase, width: '16px', height: '16px' },
  md: { ...ringBase, width: '18px', height: '18px' },
  lg: { ...ringBase, width: '22px', height: '22px' },
});

export const dot = style({
  width: '50%',
  height: '50%',
  borderRadius: vars.spacing.borderRadius.full,
  background: vars.bright.primary.default,
  transform: 'scale(0)',
  transition: `transform ${vars.animation.duration.fast} ${vars.animation.easing.easeOut}`,
  '@media': { [reducedMotion]: { transition: 'none' } },
});

export const labelText = styleVariants({
  sm: { fontSize: vars.typography.fontSize.xs },
  md: { fontSize: vars.typography.fontSize.sm },
  lg: { fontSize: vars.typography.fontSize.base },
});

// checked → bright border + visible dot
globalStyle(`${controlWrapper} input:checked + span`, {
  borderColor: vars.bright.primary.default,
});
globalStyle(`${controlWrapper} input:checked + span > span`, {
  transform: 'scale(1)',
});

// hover (only when enabled)
globalStyle(`${controlWrapper}:hover input:not(:disabled) + span`, {
  borderColor: vars.surface.border.accent,
});

// focus-visible ring
globalStyle(`${controlWrapper} input:focus-visible + span`, {
  outline: `${vars.focus.ring.width} ${vars.focus.ring.style} ${vars.focus.ring.color}`,
  outlineOffset: vars.focus.ring.offset,
  borderColor: vars.bright.primary.default,
});
